import { __awaiter } from "tslib";
import React from 'react';
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { showCarDetail, fontEndConfig } from '@/shared/utils';
import { judgeObj, judgeArr, dealValueShow, thousandBitSeparator, getDataType, dealCarNum, clearObj } from '@/shared/functions';
import styles from '@/style/color.less';
import { dispatch, getState } from '@@/store';
/**
 * @desc 条件展示列表里其他信息
 */
const showPartOtherInfo = (partName, record) => {
    const { auctionMode } = getState().bidManageDetail;
    const { status, statusStr, lineType } = record;
    switch (partName) {
        case 'goodsName':
            // 无论产品线是什么以及产品线的场次状态是什么，均展示状态；
            return (<div className={`${styles[`statusStr_${status}`]}`}>
          {statusStr}
        </div>);
        case 'highestOfferInfo':
            // 出价类型展示： 现场拍
            if (auctionMode === 1) {
                return (<span>出价类型：{lineType}<br /></span>);
            }
            return null;
        default:
            return null;
    }
};
/** @desc 创建表格列中的项函数 */
const createColumn = (title, otherProps) => {
    return (width = 150) => {
        let _tempOtherProps = {};
        getDataType(otherProps) === 'String' ? _tempOtherProps = { dataIndex: otherProps } : _tempOtherProps = otherProps;
        const _r = Object.assign({ title,
            width }, _tempOtherProps);
        width === 'none' ? delete _r.width : '';
        return _r;
    };
};
/** @desc 车辆信息 */
const goodsName = createColumn('车辆信息', {
    dataIndex: 'goodsName',
    render: (text, record, index) => (<div className="flex__row-startS">
      <div style={{
        width: 85,
        height: 64,
        marginRight: 8,
        position: 'relative',
        flexShrink: 0,
    }}>
        <div style={{
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: '#fff',
        width: '29px',
        height: '18px',
        lineHeight: '18px',
        position: 'absolute',
        top: 0,
        left: 0,
    }}>
          {record.number}
        </div>
        <img src={record.firstImage || require('@/assets/Common/carDefault.png')} width={'100%'} height={'100%'}/>
      </div>
      <div>
        <a 
    // href="javascript:;"
    onClick={() => {
        record.goodsId && showCarDetail(record.goodsId);
    }}>
        {record.goodsName}
        </a>
        
        <div style={{
        display: 'flex',
    }}>
          {showPartOtherInfo('goodsName', record)}
        </div>
      </div>
    </div>),
});
/** @desc 最高价信息 */
const highestOfferInfo = () => {
    const { roundStatus, auctionMode } = getState().bidManageDetail;
    const includeArr = [1011, 1021];
    const _text = '最高价信息';
    return createColumn(_text, {
        dataIndex: 'highestOfferInfo',
        render: (text, record, index) => {
            // 超级拍(现场拍) || 超级拍（车道拍） && 竞拍中场次
            const { buyerNameStr, tenderHighestPriorityOfferY, highestOfferY, } = record;
            if (includeArr.includes(auctionMode) && roundStatus === 2) {
                // 如果车辆是成交状态，展示买家|最高价；其他展示买家|投标最高价|竞拍最高价
                return (<div>
            买家：{buyerNameStr} <br />
            投标最高价：{tenderHighestPriorityOfferY}元<br />
            竞拍最高价：{highestOfferY}元<br />
          </div>);
            }
            return (<div>
          买家：{buyerNameStr} <br />
          最高价：{highestOfferY}元<br />
          {showPartOtherInfo('highestOfferInfo', record)}
        </div>);
        },
    });
};
/** @desc 保留价 */
const basePriceY = createColumn((<div className="tableColumn__addYuan">
    保留价
  </div>), 'basePriceY');
/** @desc 溢价信息 */
const premiumInfo = createColumn('溢价信息', {
    dataIndex: 'premiumInfo',
    render: (text, record, index) => (<div>
      溢价金额：{record.premiumPriceY}元 <br />
      溢价率：{record.premiumRate}
    </div>),
});
/** @desc 出价信息 */
const bidInfo = createColumn('出价信息', {
    dataIndex: 'bidInfo',
    render: (text, record, index) => (<div>
      出价次数：{record.bidNum}次<br />
      出价会员数：{record.bidBuyerNum}名<br />
      关注会员数：{record.fousBuyerNum}名<br />
    </div>),
});
/** @desc 操作列 出价详情|实时监控|'--'
 * 预展中和待开拍 是--
 * 投标和竞拍 实时监控
 * 其他 出价详情
*/
const columnEnd = createColumn('操作', {
    /** @desc 5期 跟新 */
    dataIndex: 'operate',
    render: (text, record, index) => {
        const { status, auctionId } = record;
        const showNone = ['1', '2', '7'];
        const showMonitor = ['9', '3'];
        const _renderOfferDetail = () => (<div className={'table-operate-btn'}>
        <a onClick={(event) => {
            dispatch.router.push({
                path: '/carManage/offerdetails',
                query: {
                    id: auctionId,
                },
            });
        }}>
          出价详情
        </a>
      </div>);
        const _renderMonitorDetail = () => (<div className={'table-operate-btn'}>
        <a onClick={() => {
            dispatch.router.push({
                path: '/carManage/RealtimeMonitoring',
                query: {
                    id: auctionId,
                },
            });
        }}>
          实时监控
        </a>
      </div>);
        const _renderNone = () => (<span style={{ cursor: 'not-allowed' }}>{fontEndConfig.noValueReplace}</span>);
        return (showNone.includes(status) ? _renderNone() : showMonitor.includes(status) ? _renderMonitorDetail() : _renderOfferDetail());
    },
});
/** @desc 是否次高价成交 */
const secondPriceDeal = createColumn('是否次高价成交', { dataIndex: 'secondPriceDealDesc' });
/** @desc 是否成交 */
const isDeal = createColumn('是否成交', 'isDeal');
/** @desc 成交价 */
const priorityOfferY = createColumn('成交价', { dataIndex: 'priorityOfferY' });
/** @desc 成交信息 包含：成交价 是否次高价成交  是否成交 */
const dealInfo = createColumn('成交信息', {
    dataIndex: 'dealInfo',
    render: (text, record, index) => (<div>
      成交价：{record.priorityOfferY}<br />
      成交方式：{record.secondPriceDeal ? record.secondPriceDeal === '1' ? '次高价成交' : '最高价成交' : fontEndConfig.noValueReplace}<br />
      是否成交：{record.isDeal}<br />
    </div>),
});
/** @desc 次高价 */
const secondOfferY = createColumn((<div className="tableColumn__addYuan">
    次高价
  </div>), { dataIndex: 'secondOfferY' });
/** @desc 是否超保留价 */
const isExceedBasePrice = createColumn('是否超保留价', { dataIndex: 'isExceedBasePrice' });
const initState = {
    columns: [],
    items: [],
    totalNum: 0,
    pageIndex: 1,
    pageSize: 20,
    tableLoading: false,
    roundStatus: 0,
    basicInfo: {},
    moneyInfo: {},
    membersInfo: {},
    selfMembersInfo: {},
    auctionMode: 0,
    roundName: '竞拍管理详情导出',
    topDetailList: {},
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 初始化加载数据
         */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                this.loadInfo({}).then((res) => {
                    // 如果是暗拍 加载部分数据
                    const { auctionMode } = res;
                    if (auctionMode === 2) {
                        this.loadAnotherInfo({});
                    }
                    this.loadColumns(res);
                });
                this.loadList({});
                this.loadTopMsg({}); // 拍卖管理-场次数据详情-头部场次信息的接口
            });
        },
        /**
         * @desc 加载表格列项
         */
        loadColumns(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { roundStatus, auctionMode } = payload;
                let _c = [];
                switch (auctionMode) {
                    case 1: // 现场拍
                    case 1001: // 车道拍
                        _c = [goodsName(300), highestOfferInfo()(210), isDeal(65),
                            basePriceY(106), premiumInfo(154), bidInfo(158), columnEnd(90)];
                        break;
                    case 2: // 暗拍
                        switch (roundStatus) {
                            case 2: // 竞价中
                                _c = [goodsName(215), highestOfferInfo()(194), secondPriceDeal(70),
                                    secondOfferY(87), isExceedBasePrice(65), basePriceY(87), premiumInfo(147),
                                    bidInfo(149), columnEnd(70)];
                                break;
                            case 3: // 已结束
                                _c = [goodsName(290), highestOfferInfo()(194), dealInfo(150), basePriceY(87), premiumInfo(147),
                                    bidInfo(149), columnEnd(70)];
                                break;
                        }
                        break;
                    case 1011: // 超级拍（现场拍）
                    case 1021: // 超级拍（车道拍）
                        switch (roundStatus) {
                            case 5: // 投标中
                            case 2: // 竞价中
                                _c = [goodsName(300), highestOfferInfo()(194), isExceedBasePrice(65),
                                    basePriceY(87), bidInfo(149), columnEnd(70)];
                                break;
                            case 3: // 已结束
                                _c = [goodsName(220), highestOfferInfo()(194), isDeal(65),
                                    basePriceY(87), premiumInfo(147), bidInfo(149), columnEnd(70)];
                                break;
                        }
                        break;
                    default:
                        throw ('场次类型错误');
                }
                this.SET_STATE({
                    columns: _c,
                });
            });
        },
        /**
         * @desc 加载数据概览，场次状态，场次类型
         */
        loadInfo(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { id: roundId } = rootState.router.query;
                const _param = { roundId };
                this.SET_STATE({ tableLoading: true });
                let rS = {};
                return Api.auction.roundMonitorInfo(_param).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (judgeObj(data)) {
                        const { roundStatus, productNumBak, dealCarNum, bidCarNum, dealRate, bidRate, premiumCarNum, exceedBasePriceCarNum, totalDealPriceY, premiumPriceY, premiumRate, buyerNum, fousBuyerNum, bidBuyerNum, auctionMode, roundName, selfFousBuyerNum, selfBidBuyerNum, } = data;
                        const temp = {
                            roundName,
                            roundStatus,
                            auctionMode,
                            basicInfo: {
                                productNumBak, dealCarNum, bidCarNum, dealRate, bidRate, premiumCarNum, exceedBasePriceCarNum,
                            },
                            moneyInfo: {
                                totalDealPriceY, premiumPriceY, premiumRate,
                            },
                            membersInfo: {
                                buyerNum, fousBuyerNum, bidBuyerNum,
                            },
                        };
                        this.SET_STATE(Object.assign({}, clearObj(temp)));
                        this.SET_selfMembers_part({ selfFousBuyerNum, selfBidBuyerNum, buyerNum });
                        rS = { roundStatus, auctionMode };
                    }
                    return rS;
                }).catch((err) => {
                    console.log(err);
                    return rS;
                }).finally(() => {
                    this.SET_STATE({ tableLoading: false });
                });
            });
        },
        /**
         * @desc 暗拍 加载数据概览 部分数据
         */
        loadAnotherInfo(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { id: roundId } = rootState.router.query;
                const _param = { roundId };
                this.SET_STATE({ tableLoading: true });
                return Api.suixinhuan.getOpenAppCount(_param).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (judgeObj(data)) {
                        // totalCount: 在线会员数 appCount: 本机构会员数
                        this.SET_onlineData(data);
                    }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.SET_STATE({ tableLoading: false });
                });
            });
        },
        /**
         * @desc 场次车辆竞拍详情接口
         */
        loadList(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { id: roundId } = rootState.router.query;
                const { pageIndex, pageSize } = state;
                const _param = { roundId, pageIndex, pageSize };
                this.SET_STATE({ tableLoading: true });
                const result = { totalNum: 0, items: [] };
                return Api.auction.roundMonitorList(_param).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = {
                            key: i,
                            number: dealCarNum(String(v.status) !== '7' ? v.auctionSerialNumber : ''),
                            goodsName: dealValueShow(v.goodsName),
                            highestOfferY: dealValueShow(thousandBitSeparator(v.highestOfferY)),
                            tenderHighestPriorityOfferY: dealValueShow(thousandBitSeparator(v.tenderHighestPriorityOfferY)),
                            buyerNameStr: dealValueShow(v.buyerNameStr),
                            lineType: dealValueShow(v.lineTypeDesc),
                            isDeal: dealValueShow(v.isDeal),
                            basePriceY: dealValueShow(thousandBitSeparator(v.basePriceY)),
                            premiumPriceY: dealValueShow(thousandBitSeparator(v.premiumPriceY)),
                            premiumRate: dealValueShow(v.premiumRate),
                            fousBuyerNum: dealValueShow(v.fousBuyerNum),
                            bidNum: dealValueShow(v.bidNum),
                            bidBuyerNum: dealValueShow(v.bidBuyerNum),
                            goodsId: v.goodsId,
                            status: v.status,
                            statusStr: dealValueShow(v.statusStr),
                            priorityOfferY: `${dealValueShow(thousandBitSeparator(v.priorityOfferY))}元`,
                            secondOfferY: dealValueShow(thousandBitSeparator(v.secondOfferY)),
                            isExceedBasePrice: dealValueShow(v.isExceedBasePrice),
                            auctionId: v.auctionId,
                            firstImage: v.firstImage,
                            secondPriceDeal: v.secondPriceDeal,
                            secondPriceDealDesc: dealValueShow(v.secondPriceDealDesc),
                        };
                        return _item;
                    });
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.SET_STATE(Object.assign({}, result));
                    this.SET_STATE({ tableLoading: false });
                });
            });
        },
        /**
         * @desc 拍卖管理-场次数据详情-头部场次信息的接口
         */
        loadTopMsg(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { id: roundId } = rootState.router.query;
                const _param = { roundId };
                return Api.auction.auctionRoundDetail(_param).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data)) {
                        return;
                    }
                    const { status, roundPic, roundName, roundCode, auctionMode, preStartTime, preStartDate, roundAddress } = data;
                    const topDetailList = {
                        status,
                        roundPic,
                        roundName,
                        roundCode,
                        auctionMode,
                        preStartTime,
                        preStartDate,
                        roundAddress,
                    };
                    this.SET_STATE({
                        topDetailList,
                    });
                });
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageIndex = payload;
        },
        SET_onlineData(state, payload) {
            const { totalCount, appCount } = payload;
            state.membersInfo.onlineBuyerNum = totalCount;
            state.selfMembersInfo.selfOnlineBuyerNum = appCount;
        },
        SET_selfMembers_part(state, payload) {
            const { selfFousBuyerNum, selfBidBuyerNum, buyerNum } = payload;
            state.selfMembersInfo.selfFousBuyerNum = selfFousBuyerNum;
            state.selfMembersInfo.selfBidBuyerNum = selfBidBuyerNum;
            state.selfMembersInfo.selfBuyerNum = buyerNum;
        },
    },
});
